import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Custom date adapter that parses dates in French format (DD/MM/YYYY).
 * The native adapter uses browser's Date.parse() which expects US format (MM/DD/YYYY).
 */
@Injectable()
export class FrenchDateAdapter extends NativeDateAdapter {
  override parse(value: string | number): Date | null {
    if (typeof value === 'number') {
      return new Date(value);
    }

    if (!value) {
      return null;
    }

    // Try to parse French format: DD/MM/YYYY or DD-MM-YYYY
    const frenchDateMatch = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/.exec(
      value.trim(),
    );
    if (frenchDateMatch) {
      const [, day, month, year] = frenchDateMatch;
      const parsedDay = parseInt(day, 10);
      const parsedMonth = parseInt(month, 10) - 1; // Month is 0-indexed
      const parsedYear = parseInt(year, 10);

      // Validate the date
      if (
        parsedDay >= 1 &&
        parsedDay <= 31 &&
        parsedMonth >= 0 &&
        parsedMonth <= 11
      ) {
        const date = new Date(parsedYear, parsedMonth, parsedDay);
        // Verify the date is valid (handles cases like 31/02/2024)
        if (
          date.getFullYear() === parsedYear &&
          date.getMonth() === parsedMonth &&
          date.getDate() === parsedDay
        ) {
          return date;
        }
      }
    }

    // Fallback to default parsing for other formats (ISO, etc.)
    return super.parse(value);
  }
}
